import {
    apiRequest,
    masterRegion,
    penataranApprove
} from "../../../../../services/adapters/kepegawaian/penataranService"

class IndexRepository {

    fetchRegion = async (query, cancelToken) => {
        return await apiRequest("get", masterRegion, {
            cancelToken: cancelToken,
            params: query
        }, true);
    }


    fetchRegionProvince = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchRegionCity = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchApprove = async (query) => {
        return await apiRequest("post", penataranApprove, {
            body: query
        }, true)
    }

}

export default IndexRepository;